import React from 'react';
import PropTypes from 'prop-types';
import {
  Checkbox,
  Flag,
  Icon,
  Image,
  Label,
  Popup,
  Table,
} from 'semantic-ui-react';

import _ from 'lodash';
import moment from 'moment';

import InfluencerTableSocialLink from '../../components/influencer-table-social-link';
import InstagramAccountType from '../../components/instagram-account-type';

import ConditionalTableElement, {
  shouldRenderSocialTableColumn,
} from '../../components/conditional-table-element/index';

import { ierFormat } from '../../utils/helpers/formatting';

const DEFAULT_IMAGE = 'https://s3-eu-west-1.amazonaws.com/discussions-uploads-production/no_image_available.png';

const badgeStyle = {
  display: 'flex',
  alignItems: 'center',
};

const avatarStyle = {
  marginRight: '10px',
};


const rowPadding = {
  padding: 8,
};
const influencerCellStyle = {
  ...rowPadding,
};

const InfluencerTableRow = props => {
  const { link, columnsSettings, displayAuthorisedData } = props;
  const id = _.get(link, 'link.id') || link.id;
  const linkCreatedDate = link.createdDate || link.lookupInfluencer.createdDate;
  const linkCreatedBy = link.createdBy || link.lookupInfluencer.createdBy;
  const tokenIsBad = _.get(link, 'lookupInfluencer.instagramStatus') === 'WARN';
  const shouldRenderTokenWarning = tokenIsBad && displayAuthorisedData;

  const influencerCreatedBy = link.lookupDetails.createdBy;
  const influencerSignupSource = link.lookupInfluencer.signupSource;

  const influencer = link.lookupInfluencer;
  const {
    countries,
  } = props;

  const {
    name,
    thumbnail,
    primarySocialHandle,
    youtube,
    youtubeCount,
    instagram,
    instagramCount,
    facebook,
    facebookCount,
    twitter,
    twitterCount,
    twitch,
    twitchCount,
    tiktok,
    tiktokCount,
    web,
    snapchat,
    linkedin,
    country,
    status,
    instagramBusinessAccount,
    instagramProfessionalAccount,
    instagramRestrictedProfile,
    instagramRestrictedProfileText,
    instagramEngagementRate,
    instagramPrivate,
  } = influencer;

  const withDemoTag = status === 'CLAIMED';

  const instagramLink = {
    href: 'https://instagram.com/',
    label: 'view on instagram',
    handle: instagram,
    color: 'pink',
  };

  const twitterLink = {
    href: 'https://twitter.com/',
    label: 'view on twitter',
    handle: twitter,
    color: 'blue',
  };

  const facebookLink = {
    href: 'https://facebook.com/',
    label: 'view on facebook',
    handle: facebook,
    color: 'blue',
  };

  const youtubeLink = {
    href: 'https://youtube.com/results?search_query=',
    label: 'view on youtube',
    handle: youtube,
    color: 'red',
  };

  const twitchLink = {
    href: 'https://twitch.tv/',
    label: 'view on twitch',
    handle: twitch,
    color: 'purple',
  };

  const tiktokLink = {
    href: 'https://www.tiktok.com/',
    label: 'view on tiktok',
    handle: tiktok,
    color: 'purple',
  };

  const rowStyle = { cursor: 'pointer' };

  const warningRowStyle = {
    ...rowStyle,
    background: '#FFDEAD',
  };

  const checkBoxValue = {
    id: influencer.id,
    linkId: id,
    name,
    thumbnail,
    primarySocialHandle,
  };

  const isSelected = _.some(props.selected, { id: influencer.id });

  const mapping = _.find(countries, ['key', country]);
  const countryName = (mapping && mapping.text) || '-';

  const getWebLink = url => {
    const httpRegEx = /^http(s?):\/\/(.*)$/i;
    const match = url.match(httpRegEx);
    const webLink = match ? url : `https://${url}`;
    return webLink;
  };

  const font90 = {
    fontSize: '90%',
    color: 'grey',
  };

  const font70 = {
    fontSize: '70%',
    color: 'grey',
  };

  const dateString = moment(linkCreatedDate).format('DD/MM/YYYY');

  return (

    <Table.Row key={id} style={shouldRenderTokenWarning ? warningRowStyle : rowStyle}>
      <Table.Cell textAlign="center" style={rowPadding}>
        <Checkbox
          checked={isSelected}
          onChange={props.onCheckboxStateUpdated}
          value={checkBoxValue}
        />
      </Table.Cell>
      <Table.Cell
        verticalAlign="middle"
        onClick={() => props.handleRowClick(id)}
        style={influencerCellStyle}
      >
        <div style={badgeStyle}>
          <div style={avatarStyle}>
            <Image
              avatar
              src={thumbnail || 'no thumbnails'}
              onError={i => { i.target.src = DEFAULT_IMAGE; }}
            />
          </div>
          <div>
            <div><b>{primarySocialHandle}</b></div>
            {
              !withDemoTag &&
                <div className="light" style={font90}>
                  { name }
                </div>
            }
            {
              withDemoTag &&
              <Label
                size="mini"
                color="pink"
                basic
              >
                DEMO
              </Label>
            }
          </div>
        </div>
      </Table.Cell>
      <Table.Cell textAlign="center" onClick={() => props.handleRowClick(id)} style={rowPadding}>
        {country && <Popup
          trigger={<Flag name={_.toLower(country)} />}
          content={countryName}
        />}
        {!country && '-'}
      </Table.Cell>
      <Table.Cell textAlign="center" onClick={() => props.handleRowClick(id)} style={rowPadding}>
        <InstagramAccountType
          instagram={instagram}
          isProfessional={instagramProfessionalAccount}
          isBusiness={instagramBusinessAccount}
          isRestricted={instagramRestrictedProfile}
          restrictedText={instagramRestrictedProfileText}
          isPrivate={instagramPrivate}
        />
      </Table.Cell>

      <ConditionalTableElement
        shouldRender={shouldRenderSocialTableColumn(columnsSettings, 'instagram_engagement_rate')}
      >
        <Table.Cell textAlign="center" onClick={() => props.handleRowClick(id)} style={rowPadding}>
          { instagramEngagementRate ? ierFormat(instagramEngagementRate) : '-' }
        </Table.Cell>
      </ConditionalTableElement>

      <ConditionalTableElement shouldRender={shouldRenderSocialTableColumn(columnsSettings, 'facebook')}>
        <Table.Cell
          collapsing textAlign="center" onClick={() => props.handleRowClick(id)} style={rowPadding}
        >
          <InfluencerTableSocialLink
            count={facebookCount}
            link={facebookLink}
            data={influencer.facebookData}
          />
        </Table.Cell>
      </ConditionalTableElement>
      <ConditionalTableElement shouldRender={shouldRenderSocialTableColumn(columnsSettings, 'instagram')}>
        <Table.Cell
          collapsing textAlign="center" onClick={() => props.handleRowClick(id)} style={rowPadding}
        >
          <InfluencerTableSocialLink
            count={instagramCount}
            link={instagramLink}
            data={influencer.instagramData}
          />
        </Table.Cell>
      </ConditionalTableElement>
      <ConditionalTableElement shouldRender={shouldRenderSocialTableColumn(columnsSettings, 'twitter')}>
        <Table.Cell
          collapsing textAlign="center" onClick={() => props.handleRowClick(id)} style={rowPadding}
        >
          <InfluencerTableSocialLink
            count={twitterCount}
            link={twitterLink}
          />
        </Table.Cell>
      </ConditionalTableElement>
      <ConditionalTableElement shouldRender={shouldRenderSocialTableColumn(columnsSettings, 'youtube')}>
        <Table.Cell
          collapsing textAlign="center" onClick={() => props.handleRowClick(id)} style={rowPadding}
        >
          <InfluencerTableSocialLink
            count={youtubeCount}
            link={youtubeLink}
            data={influencer.youtubeData}
          />
        </Table.Cell>
      </ConditionalTableElement>
      <ConditionalTableElement shouldRender={shouldRenderSocialTableColumn(columnsSettings, 'website')}>
        <Table.Cell
          collapsing textAlign="center" onClick={() => props.handleRowClick(id)} style={rowPadding}
        >
          { web ?
            <Popup
              hoverable
              trigger={<Icon name="world" color="pink" />}
              content={
                <span>
                  <Icon name="world" color="pink" />
                  <a href={getWebLink(web)} rel="noopener noreferrer" target="_blank">{web}</a>
                </span>
              }
            />
            : <span>-</span>
          }
        </Table.Cell>
      </ConditionalTableElement>
      <ConditionalTableElement shouldRender={shouldRenderSocialTableColumn(columnsSettings, 'snapchat')}>
        <Table.Cell
          collapsing textAlign="center" onClick={() => props.handleRowClick(id)} style={rowPadding}
        >
          { snapchat ?
            <Popup
              hoverable
              trigger={<Icon name="snapchat" color="pink" />}
              content={
                <span>
                  <Icon name="snapchat ghost" color="yellow" />
                  <b>{snapchat}</b>
                </span>
              }
            />
            : <span>-</span>
          }
        </Table.Cell>
      </ConditionalTableElement>
      <ConditionalTableElement shouldRender={shouldRenderSocialTableColumn(columnsSettings, 'telegram')}>
        <Table.Cell
          collapsing textAlign="center" onClick={() => props.handleRowClick(id)} style={rowPadding}
        >
          { _.get(influencer, 'telegramUser') ?
            <span><Icon name="check circle" color="green" /></span>
            : <span>-</span>
          }
        </Table.Cell>
      </ConditionalTableElement>
      <ConditionalTableElement shouldRender={shouldRenderSocialTableColumn(columnsSettings, 'twitch')}>
        <Table.Cell
          collapsing textAlign="center" onClick={() => props.handleRowClick(id)} style={rowPadding}
        >
          <InfluencerTableSocialLink
            count={twitchCount}
            link={twitchLink}
          />
        </Table.Cell>
      </ConditionalTableElement>
      <ConditionalTableElement shouldRender={shouldRenderSocialTableColumn(columnsSettings, 'tiktok')}>
        <Table.Cell
          collapsing textAlign="center" onClick={() => props.handleRowClick(id)} style={rowPadding}
        >
          <InfluencerTableSocialLink
            count={tiktokCount}
            link={tiktokLink}
          />
        </Table.Cell>
      </ConditionalTableElement>
      <ConditionalTableElement shouldRender={shouldRenderSocialTableColumn(columnsSettings, 'linkedin')}>
        <Table.Cell
          collapsing textAlign="center" onClick={() => props.handleRowClick(id)} style={rowPadding}
        >
          { linkedin ?
            <Popup
              hoverable
              trigger={<Icon name="linkedin" color="pink" />}
              content={
                <span>
                  <Icon name="linkedin" color="blue" />
                  <b>{linkedin}</b>
                </span>
              }
            />
            : <span>-</span>
          }
        </Table.Cell>
      </ConditionalTableElement>
      <Table.Cell textAlign="center">
        <Popup
          trigger={<span className="small light" style={font90}>{ dateString }</span>}
          content={`Influencer added by ${influencerCreatedBy || linkCreatedBy} on ${dateString}.`}
        />
        { linkCreatedBy &&
          <div className="small light" style={font70}>{ linkCreatedBy }
            {influencerSignupSource ? ` (${influencerSignupSource})` : ''}</div>
        }
      </Table.Cell>
    </Table.Row>
  );
};


InfluencerTableRow.propTypes = {
  onCheckboxStateUpdated: PropTypes.func.isRequired,
  handleRowClick: PropTypes.func.isRequired,
  link: PropTypes.object.isRequired,
  selected: PropTypes.array.isRequired,
  displayAuthorisedData: PropTypes.bool.isRequired,
  countries: PropTypes.array.isRequired,
  columnsSettings: PropTypes.object.isRequired,
};

export default InfluencerTableRow;



/** WEBPACK FOOTER **
 ** ./src/components/influencer-table-row/index.js
 **/